
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $5cac98e4c80e6707$exports = {};

$parcel$export($5cac98e4c80e6707$exports, "focus-ring", () => $5cac98e4c80e6707$export$f39a09f249340e2a, (v) => $5cac98e4c80e6707$export$f39a09f249340e2a = v);
$parcel$export($5cac98e4c80e6707$exports, "i18nFontFamily", () => $5cac98e4c80e6707$export$8c4ee2c50c22c514, (v) => $5cac98e4c80e6707$export$8c4ee2c50c22c514 = v);
$parcel$export($5cac98e4c80e6707$exports, "spectrum", () => $5cac98e4c80e6707$export$3311ab3a441bc141, (v) => $5cac98e4c80e6707$export$3311ab3a441bc141 = v);
$parcel$export($5cac98e4c80e6707$exports, "spectrum-Body", () => $5cac98e4c80e6707$export$a30bf7810c8453d1, (v) => $5cac98e4c80e6707$export$a30bf7810c8453d1 = v);
$parcel$export($5cac98e4c80e6707$exports, "spectrum-Body--italic", () => $5cac98e4c80e6707$export$7b2dac1166f6ec4c, (v) => $5cac98e4c80e6707$export$7b2dac1166f6ec4c = v);
$parcel$export($5cac98e4c80e6707$exports, "spectrum-FocusRing-ring", () => $5cac98e4c80e6707$export$4109102f950813a6, (v) => $5cac98e4c80e6707$export$4109102f950813a6 = v);
$parcel$export($5cac98e4c80e6707$exports, "spectrum-FocusRing", () => $5cac98e4c80e6707$export$24c7f46a6e3605dd, (v) => $5cac98e4c80e6707$export$24c7f46a6e3605dd = v);
$parcel$export($5cac98e4c80e6707$exports, "spectrum-FocusRing--quiet", () => $5cac98e4c80e6707$export$2927016961429360, (v) => $5cac98e4c80e6707$export$2927016961429360 = v);
var $5cac98e4c80e6707$export$f39a09f249340e2a;
var $5cac98e4c80e6707$export$8c4ee2c50c22c514;
var $5cac98e4c80e6707$export$3311ab3a441bc141;
var $5cac98e4c80e6707$export$a30bf7810c8453d1;
var $5cac98e4c80e6707$export$7b2dac1166f6ec4c;
var $5cac98e4c80e6707$export$4109102f950813a6;
var $5cac98e4c80e6707$export$24c7f46a6e3605dd;
var $5cac98e4c80e6707$export$2927016961429360;
$5cac98e4c80e6707$export$f39a09f249340e2a = `kDKRXa_focus-ring`;
$5cac98e4c80e6707$export$8c4ee2c50c22c514 = `kDKRXa_i18nFontFamily`;
$5cac98e4c80e6707$export$3311ab3a441bc141 = `kDKRXa_spectrum ${$5cac98e4c80e6707$export$8c4ee2c50c22c514}`;
$5cac98e4c80e6707$export$a30bf7810c8453d1 = `kDKRXa_spectrum-Body`;
$5cac98e4c80e6707$export$7b2dac1166f6ec4c = `kDKRXa_spectrum-Body--italic`;
$5cac98e4c80e6707$export$4109102f950813a6 = `kDKRXa_spectrum-FocusRing-ring`;
$5cac98e4c80e6707$export$24c7f46a6e3605dd = `kDKRXa_spectrum-FocusRing ${$5cac98e4c80e6707$export$4109102f950813a6}`;
$5cac98e4c80e6707$export$2927016961429360 = `kDKRXa_spectrum-FocusRing--quiet`;


export {$5cac98e4c80e6707$exports as default};
//# sourceMappingURL=typography_index_css.module.js.map
